<!-- 选择导出日期 -->
<template>
  <j-modal title="请选择日期" :width="450" :visible="visible" @ok="handleOk" @cancel="handleCancel">
    <a-alert
      banner
      style="position: absolute; right: 20px; width: 250px; height: 137px; padding-top: 6px; margin-top: -1px"
    >
      <template slot="message">
        <span>主页面上设置的筛选条件也将同时生效。</span>
        <br />
        <span>即、本页面上选择的日期会在主页面上设置的筛选条件的基础上，进一步缩小数据的抽出范围。</span>
      </template>
    </a-alert>
    <div>
      <dt>请选择日期模式：</dt>
      <dd>
        <a-radio-group v-model="exportUnit" button-style="solid" :disabled="this.mode">
          <a-radio-button value="month"> 月 </a-radio-button>
          <a-radio-button value="year"> 年 </a-radio-button>
        </a-radio-group>
      </dd>
    </div>

    <div style="margin-top: 20px">
      <dt>请选择导出日期：</dt>
      <dd>
        <a-calendar :fullscreen="false" v-model="selected" mode="year" :class="exportUnit == 'year' ? 'only-year' : ''" />
      </dd>
    </div>
  </j-modal>
</template>

<script>
import { putAction, postAction, getAction } from '@/api/manage'

export default {
  name: 'JSelectExportDate',
  components: {},
  props: {},
  data() {
    return {
      visible: false,
      mode: '',
      exportUnit: 'month',
      selected: new moment(),
    }
  },
  watch: {},
  created() {},
  methods: {
    handleOpen(mode) {
      this.visible = true
      this.mode = mode

      if (this.mode) {
        this.exportUnit = this.mode
      }
    },
    handleOk() {
      this.visible = false
      this.$emit('emit', this.exportUnit == 'month' ? this.selected.format('YYYY-MM') : this.selected.format('YYYY'))
    },
    handleCancel() {
      this.visible = false
      this.$emit('close')
    },
  },
}
</script>

<style scoped lang="less">
dt {
  margin-bottom: 3px;
  font-size: 15px;
  color: black;
}

dd {
  margin-bottom: 0;
}

/deep/ .ant-fullcalendar-header {
  padding: 1px 0 0px;
  text-align: left;

  .ant-radio-group {
    display: none;
  }

  [role='combobox'] {
    width: 95px;
    height: 32px;

    .ant-select-selection__rendered {
      line-height: 30px;
    }
  }
}

/deep/ .ant-fullcalendar {
  margin-top: 21px;
  margin-bottom: -18px;
  border-top: 1px solid var(--color-input-border);
}

.only-year /deep/ .ant-fullcalendar {
  display: none;
}

/deep/ .ant-fullcalendar-month-panel-tbody > tr:last-child > td {
  border-bottom: none;
}

.ant-radio-button-wrapper {
  height: 30px;
  line-height: 28px;
}

/deep/ .ant-fullcalendar-month-panel-current-cell .ant-fullcalendar-value {
  box-shadow: none;
}

/deep/ .ant-fullcalendar-value {
  height: 30px;
  line-height: 30px;
  letter-spacing: 2px;
  padding-left: 3px;
}

/deep/ .ant-select-selection__clear {
  display: none !important;
}
</style>
